var _curry1 = require('./internal/_curry1');


/**
 * Negates its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number}
 * @example
 *
 *      R.negate(42); //=> -42
 */
module.exports = _curry1(function negate(n) { return -n; });



/*****************
 ** WEBPACK FOOTER
 ** ./~/ramda/src/negate.js
 ** module id = 3183
 ** module chunks = 0
 **/